import { TalesSponsor } from "../../../utils/types/TalesSponsor";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { db, storage } from "../../../firebase/config";
import firebase from "firebase";
import ServerValue = firebase.database.ServerValue;
import FieldValue = firebase.firestore.FieldValue;

export const addSponsor = createAsyncThunk(
  "sponsor/add",
  async (sponsor: TalesSponsor) => {
    try {
      const file = sponsor.file;

      if (file) {
        const storageRef = storage.ref("sponsor");
        const prova = await storageRef
          .child(file.name ?? "logo_image.jpg")
          .put(file);
        return prova.ref.getDownloadURL().then((url) =>
          db.collection("sponsor").add({
            ...sponsor,
            logoUrl: url,
            file: null,
            show: `${sponsor.show}` === "true",
            creationDate: FieldValue.serverTimestamp(),
          }),
        );
      }
    } catch (e: any) {
      console.log(e);

      return Promise.reject(`Sponsor non aggiunto, ${e.message}`);
    }
  },
);
